<template>
  <layout :session="session" :participant="participant">
    
    <result :session="session" :ratings="ratings" :resultIdx="step == 'result1' ? 1 : 2" class="px-3"></result>
  </layout>
</template>

<script>
import Layout from '@/Pages/Live/Shared/Layout';
import Result from '@/Pages/LiveResults/Productivity/Result';

export default {
  name: 'LiveResultsResults',

  metaInfo() {
    return {
      title: `Live Results`,
    };
  },

  components: {
    Layout,
    Result,
  },

  props: ['session', 'participant', 'translations', 'ratings'],

  computed: {
    step() {
      return this.session.current_step_productivity;
    },
  },
};
</script>